<p-confirmDialog key="edit" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Form-->
<div class="MainGrid2Col">
	<label>Grade Code:</label>
	<label class="InfoText">{{ GradeLevelCD }}</label>

	<label>Grade Description:</label>
	<input [(ngModel)]="GradeLevelDesc" class="form-control" type="text" placeholder="Name or Description" />

	<label>Meal Account Credit Limit:</label>
	<p-inputNumber [(ngModel)]="MealLimit" mode="currency" currency="USD" locale="en-US" step="0.01" [showButtons]="true"></p-inputNumber>
</div>

<!--Buttons-->
<div class="Buttons">
	<button class="btn btn-primary" (click)="onEdit()">Update</button>
	<button class="btn btn-primary" (click)="onClose()">Close</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
